import { CssBaseline } from "@mui/material";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import MaterialTheme from "./components/MaterialTheme";
import ViewModeProvider from "./components/ViewMode/ViewModeProvider";
import QueryProvider from "./providers/QueryProvider";

const Main = () => {
  return (
    <ViewModeProvider>
      <MaterialTheme>
        <QueryProvider>
          <BrowserRouter>
            <CssBaseline />
            <App />
            {process.env.NODE_ENV !== "production" && (
              <ReactQueryDevtools initialIsOpen={false} />
            )}
          </BrowserRouter>
        </QueryProvider>
      </MaterialTheme>
    </ViewModeProvider>
  );
};

export default Main;
